// src/components/copiloto/tema.js — paleta do Copiloto.
//
// As cores-base são as do dashboard v2 (o objeto `C` de AgentDash.js):
// o Copiloto vive dentro do dashboard e não pode destoar dele. O lilás é
// o acento PRÓPRIO do Copiloto no design (Claude Design, out/26) — separa
// "o que a IA está fazendo" do verde, que no dashboard já significa saúde
// e sucesso.
//
// Out/26 (fase 3 da Agenda): o MESMO Copiloto entra na Agenda, que tem
// tema claro e escuro. Por isso toda cor é uma variável CSS `--cpt-*` com
// a cor do dashboard como valor padrão: no dashboard ninguém define
// `--cpt-*` e nada muda; a Agenda define as variáveis dentro da classe
// `cp-tema-agenda` (Agenda.css), apontando pros tokens `--ch-*` dela.
// Nome próprio (`--cpt-`), e não `--cp-`: o CSS da Agenda é global depois
// de carregado, e um `--cp-*` em :root vazaria pro dashboard.
//
// `v(nome, padrao)`: cada ponto que usa uma cor fixa leva a SUA cor padrão,
// pra o dashboard continuar idêntico pixel a pixel.
export const v = (nome, padrao) => `var(--cpt-${nome}, ${padrao})`;

export const C = {
  bg: v('card', '#0A0F1A'),
  bg2: v('surf', '#0E1525'),
  bg3: v('bubble', '#131C30'),
  bg4: v('scroll', '#1A2540'),
  border: v('borda', 'rgba(255,255,255,0.07)'),
  green: v('green', '#00D67C'),
  red: v('red', '#FF4560'),
  text: v('text', '#DDE4F0'),
  text2: v('text2', '#7A8799'),
  text3: v('text3', '#3E4D60'),
};

export const ACENTO = {
  base: '#9184d9',
  claro: v('claro', '#d2cefd'),          // --color-accent-300 do design
  maisClaro: v('mais-claro', '#e7e5fe'), // hover
};

// Cores fixas que se repetem pelos cards, com o valor do dashboard.
export const T = {
  hover: v('hover', 'rgba(255,255,255,0.04)'),
  linha: (padrao) => v('linha', padrao),
  cardBorda: v('card-borda', 'rgba(255,255,255,0.08)'),
  rodape: v('rodape', 'rgba(255,255,255,0.015)'),
  sobreVerde: v('sobre-verde', '#060d14'),
  verdeHover: v('verde-hover', '#00f090'),
  ambar: v('ambar', '#FFAA00'),
  ambarBg: v('ambar-bg', 'rgba(255,170,0,0.10)'),
  ambarB: v('ambar-b', 'rgba(255,170,0,0.28)'),
  verdeBg: v('verde-bg', 'rgba(0,214,124,0.10)'),
  verdeB: (padrao) => v('verde-b', padrao),
  vermelhoBg: (padrao) => v('vermelho-bg', padrao),
  vermelhoB: (padrao) => v('vermelho-b', padrao),
  neutroBg: (padrao) => v('neutro-bg', padrao),
  neutroB: v('neutro-b', 'rgba(255,255,255,0.10)'),
  brilho: v('brilho', '#232046'),
  sombra: v('sombra', '0 0 0 4px rgba(145,132,217,0.06), 0 10px 30px rgba(0,0,0,0.28)'),
};

export const FONT_NUM = "'Outfit', sans-serif";
export const FONT_TXT = "'Syne', sans-serif";
